module.exports = __webpack_public_path__ + "img/4.0fa5b3eb.svg";